import React from 'react';
import EditButton from '../EditButton';
import styles from './styles.module.scss';

const PatientConsentHeader = ({ onHandleEditClick, showEditButton }) => (
  <div className={styles.patientConsentLines}>
    <div className={styles.patientConsentHeader}>
      <div className={styles.patientConsentHeaderText}>
        Patient Consent For Medical Records Exchange
      </div>
      <EditButton onHandleClick={onHandleEditClick} isHidden={showEditButton} />
    </div>
  </div>
)

export default PatientConsentHeader;